<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $t("view") }} {{ $t("voucher") }} {{ $t("usage") }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button variant="default" to="vouchers" class="btn-blue"
          >{{ $t("voucher") }} {{ $tc("list", 1) }}</b-button
        >
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $tc("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="white-wrapper mt-3">
      <div class="row mb-2">
        <div class="col-3">
          <div>
            <b-form-input
              v-debounce:500="onSearchVoucherCode"
              v-model="searchValue"
              v-on:search="onSearchVoucherCode"
              type="search"
              :placeholder="$tc('searchs')"
            ></b-form-input>
          </div>
        </div>
        <div class="col-9">
          <div class="row justify-content-end">
            <div class="col-lg-6 col-xl-4 align-self-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="from_date"
                    v-on:click="from_date = ''"
                  >
                    ✖
                  </button>
                  <Datepicker
                    v-model="from_date"
                    ref="from_date"
                    typeable
                  ></Datepicker>
                  <label :class="from_date ? 'active' : ''">{{
                    $t("fromdate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-4 align-self-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="to_date"
                    v-on:click="to_date = ''"
                  >
                    ✖
                  </button>
                  <Datepicker
                    v-model="to_date"
                    ref="to_date"
                    typeable
                  ></Datepicker>
                  <label :class="to_date ? 'active' : ''">{{
                    $t("todate")
                  }}</label>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-xl-2 align-self-center">
              <button
                @click.prevent.stop="onSearchVoucherCode()"
                class="btn btn-blue w-100 px-2"
              >
                {{ $t("apply_filter") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-2 font-weight-bold">
        {{ $t("total") }} {{ $tc("ticket", 1) }} {{ $t("sold") }} - {{ rows }}
      </div>
      <div class="swc-report">
        <table class="swc-report-table mb-2" border="1">
          <thead>
            <tr class="dark_back">
              <th>{{ $t("voucher") }}</th>
              <th>{{ $t("voucher") }} {{ $t("code") }}</th>
              <th>{{ $t("Sales Channel") }}</th>
              <th>{{ $tc("cinema", 1) }}</th>
              <th>
                {{ $tc("movie", 1) }} / {{ $tc("item") }} {{ $t("name") }}
              </th>
              <th>{{ $t("show") }} {{ $t("datetime") }}</th>
              <th>{{ $t("time") }} {{ $t("usage") }}</th>
              <th>{{ $t("client_name") }}</th>
              <th>{{ $t("client") }} {{ $t("shareValue") }}</th>
              <th>{{ $t("discount") }} {{ $t("amount") }}</th>
              <th>{{ $t("grossAmount") }}</th>
              <th>{{ $t("transaction_id") }}</th>
              <th>{{ $t("comment") }}</th>
              <th>{{ "User Name" }}</th>
            </tr>
          </thead>
          <tbody v-if="Records.length > 0">
            <tr
              v-for="(singleRecord, IndexKey) in Records"
              :key="IndexKey"
              class="light_grey_back"
              :class="getDisabledRow(singleRecord) ? 'text-danger' : ''"
            >
              <td>{{ singleRecord.voucher_title }}</td>
              <td>{{ singleRecord.voucher_code }}</td>
              <td class="text-left">
                {{ singleRecord.bs_source || singleRecord.fst_booking_source }}
              </td>
              <td class="text-left">
                {{ singleRecord.cine_name || singleRecord.cinema_name }}
              </td>
              <td
                class="text-left"
                v-if="
                  singleRecord.movie_title &&
                  singleRecord.movie_title.length > 0
                "
              >
                {{ singleRecord.movie_title || singleRecord.item_name }} ({{
                  singleRecord.mf_name
                }}) ({{ singleRecord.lang_name }})
              </td>
              <td v-else class="text-left">
                {{ singleRecord.item_name || singleRecord.recipe_name }}
              </td>
              <td class="text-right">
                {{ singleRecord.t_show_date | dateparse }}
                <br />
                {{ singleRecord.t_show_time }}
              </td>
              <td class="text-right">
                {{ singleRecord.created_at | dateparse }}
                <br />
                {{ singleRecord.created_at_time }}
              </td>
              <td class="text-left">{{ singleRecord.client_name || "-" }}</td>
              <td class="text-right">{{ singleRecord.client_share_value }}</td>
              <td class="text-right">
                {{ singleRecord.t_offer_price || singleRecord.ft_offer_price }}
              </td>
              <td class="text-right">
                {{
                  singleRecord.total_amount ||
                  singleRecord.ft_gross_amount_before_offer
                }}
              </td>
              <td>
                {{
                  singleRecord.sb_booking_code || singleRecord.fnb_order_code
                }}
              </td>
              <td>{{ singleRecord.comment ? singleRecord.comment : "-" }}</td>
              <td>{{ singleRecord.pos_user ? singleRecord.pos_user : "-" }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="9">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        href="#"
        v-if="Records.length > 0"
        class="d-flex justify-content-end mt-3 align-items-center"
      >
        <!-- @click="excelDownload(BASE_URL, 'pdf')" -->
        <div>{{ $t("download") }} as:</div>
        <!-- 
        <a title="Download as PDF">
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a> -->
        <a
          href="#"
          @click="excelDownload(BASE_URL, 'excel')"
          title="Download as Excel"
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div>
    <b-pagination
      v-if="Records && Records.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "@/services/ApiHelper";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      roleID: "",
      voucher_id: "",
      Records: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      voucher_id: 0,
      searchValue: "",
      from_date: null,
      to_date: null,
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;
    const { voucher_id } = this.$route.query;
    this.voucher_id = voucher_id;

    // this.getCountriesList();

    if (voucher_id) {
      this.getVoucherUsageDetails(voucher_id);
    } else {
      const { voucher_id } = this.$route.query;
      this.voucher_id = this.$route.query.voucher_id;

      if (voucher_id) {
        this.getVoucherUsageDetails(voucher_id);
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {},
  methods: {
     onSearchVoucherCode() {
        this.currentPage = 1;
        this.getVoucherUsageDetails();
      },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    getDisabledRow(data) {
      let status = false;
      if (data.hasOwnProperty("is_refund") && data.is_refund == "Y") {
        status = true;
      } else if (
        data.hasOwnProperty("is_fnb_refund") &&
        data.is_fnb_refund == "Y"
      ) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
    excelDownload(BASE_URL, type) {
      let payload = {
        type: type,
        voucher_id: this.voucher_id,
        limit: 100000 || this.perPage,
        currentPage: 1 || this.currentPage,
        searchValue: this.searchValue || null,
        from_date:
            this.from_date && moment(this.from_date).isValid()
              ? moment(this.from_date).format("YYYY-MM-DD")
              : null,
          to_date:
            this.to_date && moment(this.to_date).isValid()
              ? moment(this.to_date).format("YYYY-MM-DD")
              : null,
      };

      console.log(payload);
      let qs = createQueryString(payload);
      console.log(qs);
      window.open(`${BASE_URL}/api/admin/reports/v2/voucher-usage${qs}`);
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getVoucherUsageDetails();
      } else {
        this.currentPage = event;
        this.getVoucherUsageDetails();
      }
    },
    getVoucherUsageDetails: function (voucher_id) {
      let loader = this.$loading.show();
      this.Records = [];
      MarketingService.GetVoucherUsage({
        voucher_id: voucher_id || this.voucher_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue || null,
        from_date:
            this.from_date && moment(this.from_date).isValid()
              ? moment(this.from_date).format("YYYY-MM-DD")
              : null,
          to_date:
            this.to_date && moment(this.to_date).isValid()
              ? moment(this.to_date).format("YYYY-MM-DD")
              : null,
      })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Records = data.Records;
            this.rows = data.totalRows;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/VouchersComponent/viewVouchersUsage.vue